import Vue from 'vue';
import App from './App.vue';
import VueLazyLoad from 'vue-lazyload';
import VueRouter from 'vue-router';
import { routes } from './router.js';
import Vuex from 'vuex';
import store from './store';
import axios from 'axios';
import { firestorePlugin } from 'vuefire';
import Multiselect from 'vue-multiselect';

// register globally
Vue.component('multiselect', Multiselect);

Vue.use(firestorePlugin);

Vue.prototype.$axios = axios;
import VueScrollmagic from 'vue-scrollmagic';
import i18n from './i18n';

Vue.use(VueRouter);

Vue.use(VueLazyLoad);

Vue.use(Vuex);

Vue.use(VueScrollmagic);

Vue.config.productionTip = false;

const router = new VueRouter({
	routes,
	mode: 'history',
	linkActiveClass: 'active',
	linkExactActiveClass: 'exact-active',
});

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {
	// use the language from the routing param or default language
	let language = to.params.lang;
	if (!language) {
		language = 'en';
	}

	// set the current language for i18n.
	i18n.locale = language;
	next();
});

new Vue({
	render: (h) => h(App),
	router,
	store,
	i18n,
	mode: 'history',
}).$mount('#app');
